var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-plus_black"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus_black",
    clipPath: "url(#clip-plus_black)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21138",
    "data-name": "Path 21138",
    d: "M14.751,7.076H8.275V.6a.6.6,0,0,0-1.2,0V7.076H.6a.6.6,0,0,0,0,1.2H7.076v6.476a.6.6,0,0,0,1.2,0V8.275h6.476a.6.6,0,1,0,0-1.2Z",
    transform: "translate(2.516 2.516)",
    fill: "#2f394e",
    stroke: "#2f394e",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlack);
export default __webpack_public_path__ + "static/media/plus_black.75127cf8c250f05968930e22a8f558c3.svg";
export { ForwardRef as ReactComponent };